import { createSelector } from '@reduxjs/toolkit';
import { State } from '@/apps/appCreator/store';

const getDealerOffices = createSelector(
  (state: State) => state.dealers.dealers,
  (state: State) => state.dealers.selectedDealer,
  (state: State, city: string) => city,
  (dealers, selectedDealer, city) => {
    if (!dealers && !selectedDealer) {
      return undefined;
    }

    const dealer = dealers?.find(d => d.id === selectedDealer);

    if (city) {
      return dealer?.offices.filter(office => office.city === city);
    }

    return dealer?.offices;
  }
);

export default getDealerOffices;
